import { apiClient, apiGet, apiPost, apiPut, apiDelete } from "@/lib/api/client";
import type { PaginatedParams, PaginatedResponse } from "@/lib/api/types";

const BASE = "/events";

export const eventsApi = {
  list: (params?: PaginatedParams & { type?: string; status?: string }) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    if (params?.sort) searchParams.set("sort", params.sort);
    if (params?.order) searchParams.set("order", params.order);
    if (params?.type) searchParams.set("type", params.type);
    if (params?.status) searchParams.set("status", params.status);
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`${BASE}?${searchParams.toString()}`);
  },

  getById: (id: string) => apiGet<{ event: Record<string, unknown> }>(`${BASE}/${id}`),

  create: (data: Record<string, unknown>) => apiPost<{ event: Record<string, unknown> }>(BASE, data),

  update: (id: string, data: Record<string, unknown>) =>
    apiPut<{ event: Record<string, unknown> }>(`${BASE}/${id}`, data),

  delete: (id: string) => apiDelete<{ message: string }>(`${BASE}/${id}`),

  register: (id: string) => apiPost<{ registration: Record<string, unknown> }>(`${BASE}/${id}/register`),

  unregister: (id: string) => apiPost<{ message: string }>(`${BASE}/${id}/unregister`),

  getAttendees: (id: string) => apiGet<{ attendees: Record<string, unknown>[] }>(`${BASE}/${id}/attendees`),
};
